<div class="text-center my-5">
  <ng-container *ngIf="wizardType === wizardTypes.ChildRegistration; else defaultMessage">
    <p>Child accounts were successfully created. <em>Please click the button below to return to the portal.</em></p>
    <a class="btn btn-primary" [routerLink]="['/guardians']">Go Back</a>
  </ng-container>

  <ng-template #defaultMessage>
    <p>Your account has been successfully created. <em>Please click the button below to log in.</em></p>
    <a class="btn btn-primary" [routerLink]="['/']">Login</a>
  </ng-template>
</div>
